// Mounts the platform-provided nomenclature-type detail/edit route at
// /admin/nomenclature/$typeCode. Types are keyed by `code`; the platform
// route reads the `typeCode` param.

import { nomenclatureTypeDetailRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/nomenclature/$typeCode')({
  ...nomenclatureTypeDetailRoute,
  staticData: {
    breadcrumb: 'Type',
  },
})
